import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const getOverview = async (args?: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admin/dispatch/overview`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getActiveDeliveryMen = async (args?: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admin/dispatch/active-delivery-men`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getSidebarStats = async (args?: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admin/dispatch/sidebar-stats`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  getOverview,
  getActiveDeliveryMen,
  getSidebarStats,
};
